import React, { useMemo } from 'react';
import { classNames } from '../tools/helpers';
import Logo from './Logo';

export default function Footer({ data, className }) {
    const splitDescription = useMemo(
        () => data?.footer_copyright?.description?.split('|') || [],
        [data],
    );

    const splitAdditionalServices = useMemo(
        () => data?.additional_services?.description?.split('|') || [],
        [data],
    );

    const links = splitAdditionalServices
        .map((str) => {
            const split = str.split('@');
            if (split.length >= 2) {
                return {
                    title: split[0],
                    href: split[1],
                };
            }
            return false;
        })
        .filter(Boolean);

    const contacts = [
        {
            icon: 'map',
            linkUrl: data?.footer_map?.link_url,
            imageSrc: data?.footer_map?.image_src,
            imageAlt: data?.footer_map?.image_alt,
            description: data?.footer_map?.description,
        },
        {
            icon: 'mail',
            linkUrl: data?.footer_email?.link_url,
            imageSrc: data?.footer_email?.image_src,
            imageAlt: data?.footer_email?.image_alt,
            description: data?.footer_email?.description,
        },
    ];
    const socials = [
        {
            icon: 'fb',
            linkUrl: data?.footer_facebook?.link_url,
            imageSrc: data?.footer_facebook?.image_src,
            imageAlt: data?.footer_facebook?.image_alt,
            description: data?.footer_facebook?.description,
        },
        {
            icon: 'ig',
            linkUrl: data?.footer_instagram?.link_url,
            imageSrc: data?.footer_instagram?.image_src,
            imageAlt: data?.footer_instagram?.image_alt,
            description: data?.footer_instagram?.description,
        },
    ];
    return (
        <div
            className={classNames(
                'flex flex-col gap-10 gap-y-[60px] sm:flex-row',
                className,
            )}
        >
            <div className={'max-w-[456px]'}>
                <Logo />
                <p className={'m-0 text-apart-black-50 leading-[28px] mt-4'}>
                    {data?.footer?.description ||
                        `Menyediakan apartemen kos dengan jumlah terbatas, dirancang
                    khusus untuk memenuhi kebutuhan anak muda dan pelajar
                    modern.`}
                </p>
                <ul
                    className={
                        'text-apart-black-50 leading-[28px] space-y-5 p-0 m-0 mt-[26px]'
                    }
                >
                    {contacts.map((contact, index) => (
                        <li key={index} className={'flex items-start gap-2'}>
                            <a
                                href={contact.linkUrl}
                                className={'p-0 h-8 w-8 flex-shrink-0'}
                            >
                                <img
                                    src={contact.imageSrc}
                                    alt={contact.imageAlt}
                                />
                            </a>
                            <span className={'pt-0.5'}>
                                {contact.description}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={'space-y-3 sm:space-y-3'}>
                <p className={'m-0'}>{data?.additional_services?.title}</p>
                <ul className={'leading-[28px] m-0 p-0 space-y-2 sm:space-y-4'}>
                    {links.map((link, index) => (
                        <li
                            key={index}
                            className={'flex items-center gap-4 sm:gap-6'}
                        >
                            <a
                                href={link.href}
                                target="_blank"
                                rel="noreferrer"
                                className={'!no-underline'}
                            >
                                <span
                                    className={
                                        'text-nowrap text-apart-black-50'
                                    }
                                >
                                    {link.title}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={'sm:ml-auto sm:text-right'}>
                <p className={'m-0'}>Social Media</p>
                <ul className={'flex gap-4 p-0 m-0 mt-3 sm:justify-end'}>
                    {socials.map((social, index) => (
                        <a
                            key={index}
                            href={social.linkUrl}
                            className={'h-10 w-10 p-0'}
                        >
                            <img src={social.imageSrc} alt={social.imageAlt} />
                        </a>
                    ))}
                </ul>
                <p className={'m-0 text-apart-black-50 mt-8'}>
                    {splitDescription.length >= 1 && splitDescription[0]}{' '}
                    {new Date().getFullYear()}{' '}
                    {splitDescription.length >= 2 && splitDescription[1]}
                </p>
            </div>
        </div>
    );
}
